export default {
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.blog": "Guide",
  "nav.contact": "Contact",
  "hero.title1": "Hipobuy",
  "hero.title2": "Spreadsheet",
  "hero.subtitle": "L'outil ultime de suivi e-commerce intelligent. Optimisez votre business avec un système de hipobuy spreadsheet conçu pour le suivi produit, l'analyse des ventes et l'automatisation des données e-commerce.",
  "hero.cta1": "Hipobuy Spreadsheet",
  "hero.cta2": "Buy It Now",
  "categories.heading": "Nos Catégories",
  "categories.subtitle1": "Explorez",
  "categories.subtitle2": "nos univers",
  "value.title": "Hipobuy Spreadsheet – L'outil ultime de suivi e-commerce intelligent",
  "value.tag1": "Suivi Produit",
  "value.tag2": "Analyse Prix",
  "value.tag3": "Dropshipping",
  "value.why": "Pourquoi Nous",
  "value.whyTitle": "Une solution avancée de gestion et de suivi des produits",
  "value.whyDesc": "Le Hipobuy Spreadsheet est conçu pour les vendeurs e-commerce modernes. Il permet de suivre les performances produits en temps réel, d'analyser les prix concurrents automatiquement et d'optimiser les décisions d'achat. Centralisez toutes vos données dans un seul spreadsheet intelligent.",
  "features.title": "Pourquoi choisir Hipobuy Spreadsheet ?",
  "features.items": "✔ Remplace Excel manuel · ✔ Automatise le suivi produit · ✔ Améliore les marges e-commerce · ✔ Compatible dropshipping, Shopify et Amazon · ✔ Analyse de données simplifiée",
  "testimonials.label": "Avis Vérifié",
  "cta.title": "Prêt à remplacer Excel ?",
  "cta.subtitle": "Découvrez pourquoi les vendeurs choisissent hipobuy spreadsheet",
  "cta.button": "Accéder à la Plateforme",
  "cta.final": "Rejoignez les utilisateurs qui optimisent déjà leur business avec Hipobuy Spreadsheet",
  "comparison.title": "Aperçu comparatif rapide",
  "article.title": "Guide Hipobuy Spreadsheet",
  "article.cta": "Lire le guide complet",
  "footer.title": "Hipobuy Spreadsheet",
  "footer.desc": "L'outil de suivi e-commerce nouvelle génération. Automatisez, analysez et développez votre business en ligne avec un spreadsheet intelligent.",
  "footer.subscribe": "S'abonner",
  "footer.emailPlaceholder": "Votre adresse email",
  "footer.navigation": "Navigation",
  "footer.contact": "Contact",
  "footer.address": "Adresse",
  "footer.copyright": "© 2025 Hipobuy Spreadsheet. Tous droits réservés.",
  "footer.privacy": "Confidentialité",
  "footer.terms": "Conditions",
};